exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vat[data-v-3ad2e6d3] {\n  min-height: 23px !important;\n  width: 40px;\n  margin-top: -3px;\n  font-weight: bold;\n  text-align: right;\n}\n.error-input[data-v-3ad2e6d3] {\n  border: 1px solid red !important;\n}\n", ""]);

// exports
